import {ofType} from 'redux-observable';
import {of} from 'rxjs';
import i18next from 'i18next';
import {flatMap} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import * as EmployeeActions from 'web-app/react/entities/employees/actions';
import {showDialogObservable, DialogChoice} from 'web-app/react/dialog';

import * as Actions from './actions';

const updateKeyChildren = (action$, state$) =>
    action$.pipe(
        ofType(Actions.updateKeyChildren.type),
        flatMap(({payload}) => {
            const updateObservable = of(
                EmployeeActions.updateKeyChildren.action(payload.employeeId, payload.keyChildren),
            );

            if (payload.deletingChild) {
                const childName = payload.deletingChild.name.fullName;
                const employee = state$.value.entities.employees.get(payload.employeeId);
                const employeeName = employee && employee.name.fullName;

                return showDialogObservable({
                    title: '',
                    description: i18next.t('employeeProfile.keyChildren.confirmRemoveDescription', {
                        childName,
                        employeeName,
                    }),
                }).mergeMap(selection => {
                    if (selection === DialogChoice.OK) {
                        return updateObservable;
                    } else {
                        return of(Actions.updateKeyChildrenAborted.action());
                    }
                });
            } else {
                return updateObservable;
            }
        }),
    );

const updateKeyChildrenSuccess = action$ =>
    action$.pipe(
        ofType(EmployeeActions.updateKeyChildrenSuccess.type),
        flatMap(() => {
            return [
                GlobalEventActions.updateSuccess.action(i18next.t('employeeProfile.keyChildren.updateSuccess')),
                Actions.updateKeyChildrenSuccess.action(),
                Actions.hideAddKeyChildModal.action(),
            ];
        }),
    );

const updateKeyChildrenFailed = action$ =>
    action$.pipe(
        ofType(EmployeeActions.updateKeyChildrenFailed.type),
        flatMap(({payload}) => {
            return of(Actions.updateKeyChildrenFailed.action(payload.error));
        }),
    );

export default combineEpics(updateKeyChildren, updateKeyChildrenSuccess, updateKeyChildrenFailed);
